import { useSelector } from 'react-redux';
import ErrorBoundary from 'conversations-error-reporting/error-boundaries/components/ErrorBoundary';
import ContextualSidebarContainer from '../../crm-integration/components/ContextualSidebarContainer';
import { useCurrentViewIsProcessing } from '../../custom-views/hooks/useCurrentViewIsProcessing';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { getCurrentViewId } from '../../thread-list/selectors/getCurrentViewId';
import { useInboxViewMembers } from 'find-and-filter-data/view-members-data/public';
import { jsx as _jsx } from "react/jsx-runtime";
const InboxContextualSidebar = ({
  focusedThreadId
}) => {
  const inboxId = useSelector(getCurrentInboxId);
  const currentViewId = useSelector(getCurrentViewId);
  const {
    loading: isLoadingThreadListMembers
  } = useInboxViewMembers({
    inboxId,
    skip: true,
    viewId: currentViewId || undefined
  });
  const isCurrentViewEvaluating = useCurrentViewIsProcessing();
  // don't render sidebar during custom view evaluation
  if (isCurrentViewEvaluating) return null;
  if (!focusedThreadId && !isLoadingThreadListMembers) return null;
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    errorLoggingTitle: "InboxContextualSidebar",
    children: /*#__PURE__*/_jsx(ContextualSidebarContainer, {
      threadId: focusedThreadId
    })
  });
};
InboxContextualSidebar.displayName = 'InboxContextualSidebar';
export default InboxContextualSidebar;